module.exports = __webpack_public_path__ + "img/cloud2_4.c712d743.png";